import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzSmd } from './pages'

type TIdToPageMapWoofzSmd = Record<PageIdWoofzSmd, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_SMD: TIdToPageMapWoofzSmd = {
  [PageIdWoofzSmd.DOG_AGE_SMD]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd/pages/questions/DogAge').then((m) => ({
        default: m.DogAge,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_smd/pages/questions/DogAge'),
  },
  [PageIdWoofzSmd.DOG_SEX_SMD]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd/pages/questions/SexQuestion').then(
        (m) => ({
          default: m.SexQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd/pages/questions/SexQuestion'),
  },
  [PageIdWoofzSmd.DOG_BREED_SMD]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_smd/pages/questions/dog-breed/DogBreedQuestion'
      ).then((m) => ({
        default: m.DogBreedQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_smd/pages/questions/dog-breed/DogBreedQuestion'
      ),
  },
  [PageIdWoofzSmd.URGE_SMD]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd/pages/urge/UrgePage').then((m) => ({
        default: m.UrgePage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_smd/pages/urge/UrgePage'),
  },
  [PageIdWoofzSmd.GOALS_SMD]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd/pages/questions/GoalsQuestion').then(
        (m) => ({
          default: m.GoalsQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd/pages/questions/GoalsQuestion'),
  },
  [PageIdWoofzSmd.URGE_1_SMD]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd/pages/urge/Urge1Page').then((m) => ({
        default: m.Urge1Page,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_smd/pages/urge/Urge1Page'),
  },
  [PageIdWoofzSmd.AGRESSIVE_BEHAVIOR_SMD]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd/pages/questions/AgressiveBehavior').then(
        (m) => ({
          default: m.AgressiveBehavior,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd/pages/questions/AgressiveBehavior'),
  },
  [PageIdWoofzSmd.TRIGGERS_SMD]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd/pages/questions/TriggersQuestion').then(
        (m) => ({
          default: m.TriggersQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd/pages/questions/TriggersQuestion'),
  },
  [PageIdWoofzSmd.URGE_2_SMD]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd/pages/urge/UrgePageVariant2').then(
        (m) => ({
          default: m.UrgePageVariant2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd/pages/urge/UrgePageVariant2'),
  },
  [PageIdWoofzSmd.BEHAVIOR_ISSUES_SMD]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd/pages/questions/BehaviorIssues').then(
        (m) => ({
          default: m.BehaviorIssues,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd/pages/questions/BehaviorIssues'),
  },
  [PageIdWoofzSmd.DOG_LISTEN_SMD]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd/pages/questions/DogListen').then((m) => ({
        default: m.DogListen,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_smd/pages/questions/DogListen'),
  },
  [PageIdWoofzSmd.COMMANDS_SMD]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd/pages/questions/DogCues').then((m) => ({
        default: m.DogCues,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_smd/pages/questions/DogCues'),
  },
  [PageIdWoofzSmd.EAT_OFF_THE_GROUND_SMD]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd/pages/questions/EatOffTheGround').then(
        (m) => ({
          default: m.EatOffTheGround,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd/pages/questions/EatOffTheGround'),
  },
  [PageIdWoofzSmd.DOG_ACT_SMD]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd/pages/questions/DogActQuestion').then(
        (m) => ({
          default: m.DogActQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd/pages/questions/DogActQuestion'),
  },
  [PageIdWoofzSmd.DOG_OFF_AT_HOME_SMD]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd/pages/questions/DogOffAtHome').then(
        (m) => ({
          default: m.DogOffAtHome,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd/pages/questions/DogOffAtHome'),
  },
  [PageIdWoofzSmd.PREPARE_SCREEN_SMD]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd/pages/urge/UrgePrepareScreen').then(
        (m) => ({
          default: m.UrgePrepareScreen,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd/pages/urge/UrgePrepareScreen'),
  },
  [PageIdWoofzSmd.DOG_PROFILE_SMD]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd/pages/dog-profile/DogProfile').then(
        (m) => ({
          default: m.DogProfile,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd/pages/dog-profile/DogProfile'),
  },
  [PageIdWoofzSmd.HEAR_ABOUT_WOOFZ_SMD]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd/pages/questions/HearAboutWoofz').then(
        (m) => ({
          default: m.HearAboutWoofz,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd/pages/questions/HearAboutWoofz'),
  },
  [PageIdWoofzSmd.MANNERS_TO_BUILD_SMD]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd/pages/questions/MannersToBuild').then(
        (m) => ({
          default: m.MannersToBuild,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd/pages/questions/MannersToBuild'),
  },
  [PageIdWoofzSmd.FEEL_BETTER_SMD]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd/pages/questions/FeelBetter').then(
        (m) => ({
          default: m.FeelBetter,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/woofz_smd/pages/questions/FeelBetter'),
  },
  [PageIdWoofzSmd.PREPARE_FLOW_SMD]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd/pages/prepare-flow/PrepareFlow').then(
        (m) => ({
          default: m.PrepareFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd/pages/prepare-flow/PrepareFlow'),
  },
  [PageIdWoofzSmd.EMAIL_SMD]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd/pages/email/Email').then((m) => ({
        default: m.Email,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_smd/pages/email/Email'),
  },
  [PageIdWoofzSmd.NEWSLETTER_URGE_SMD]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd/pages/email/NewsletterUrge').then(
        (m) => ({
          default: m.NewsletterUrge,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/woofz_smd/pages/email/NewsletterUrge'),
  },
  [PageIdWoofzSmd.SCRATCH_SCREEN_SMD]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_smd/pages/last-chance-offer/LastChanceOfferScratch'
      ).then((m) => ({
        default: m.LastChanceOfferScratch,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_smd/pages/last-chance-offer/LastChanceOfferScratch'
      ),
  },
  [PageIdWoofzSmd.SUBSCRIPTIONS_SMD]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd/pages/subscriptions/Subscriptions').then(
        (m) => ({
          default: m.Subscriptions,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd/pages/subscriptions/Subscriptions'),
  },
  [PageIdWoofzSmd.CHAT_UPSELL_SMD]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd/pages/upsell/ChatUpsellNewFlow').then(
        (m) => ({
          default: m.ChatUpsellNewFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd/pages/upsell/ChatUpsellNewFlow'),
  },
  [PageIdWoofzSmd.UPSELL_SMD]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_smd/pages/upsell/Upsell'),
  },
  [PageIdWoofzSmd.UPSELL_FEEDING_GUIDE_SMD]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd/pages/upsell/FeedingGuideUpsell').then(
        (m) => ({
          default: m.FeedingGuideUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd/pages/upsell/FeedingGuideUpsell'),
  },
  [PageIdWoofzSmd.UPSELL_EMOTIONAL_SUPPORT_SMD]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_smd/pages/upsell/EmotionalSupportUpsell'
      ).then((m) => ({
        default: m.EmotionalSupportUpsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd/pages/upsell/EmotionalSupportUpsell'),
  },
  [PageIdWoofzSmd.DOWNLOAD_SMD]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd/pages/download-app/DownloadApp').then(
        (m) => ({
          default: m.DownloadApp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd/pages/download-app/DownloadApp'),
  },
  [PageIdWoofzSmd.ACCOUNT_SMD]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd/modules/account/AccountSmd').then(
        (m) => ({
          default: m.AccountSmd,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/woofz_smd/modules/account/AccountSmd'),
  },
}
